module.exports = "<table class=\"middleContainer1\">\r\n    <tr>\r\n        <td>\r\n            <div class=\"loginTop\">\r\n                <span id=\"log\"></span>\r\n                <div class=\"loginContainer\"> </div>\r\n            </div>\r\n            <div class=\"loginMiddle\">\r\n                <login-form></login-form>\r\n            </div>\r\n\r\n            <div class=\"loginBottom\">\r\n<!--                <span class=\"zhirenkeji\">Copyright 1998 -2021 Tencent. All Rights Reserved</span>-->\r\n            </div>\r\n        </td>\r\n    </tr>\r\n</table>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/conciseTemplate/ConciseLogin.html
// module id = 111
// module chunks = 0